import React from 'react';

const TimeReset = ({ onReset }) => {
  return (
    <button onClick={onReset}>
      Reset Time
    </button>
  );
};

export default TimeReset;
